import Stack from "@mui/material/Stack";
import PropTypes from "prop-types";

export function Flex({ children, ...props }) {
  const { align, direction, justify, ...rest } = props;

  if (props.hidden) return null;

  return (
    <Stack
      alignItems={align || "center"}
      flexDirection={direction || "row"}
      justifyContent={justify || "flex-start"}
      spacing={2}
      {...rest}
      useFlexGap
    >
      {children}
    </Stack>
  );
}

Flex.propTypes = {
  children: PropTypes.node.isRequired,
  alignItems: PropTypes.string,
  direction: PropTypes.string,
  justifyContent: PropTypes.string,
  spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.object,
};
